import { createAction, props } from '@ngrx/store';

import { Payment, Transaction } from '@models';

// fetch payments
export const fetchPayments = createAction('[Payment] Fetch Payments');
export const fetchPaymentsSuccess = createAction(
  '[Payment] Fetch Payments Success',
  props<{ payments: Payment[] }>()
);
export const fetchPaymentsFailed = createAction(
  '[Payment] Fetch Payments Failed',
  props<{ error: Error }>()
);

// fetch payment by id
export const fetchCurrentPaymentById = createAction(
  '[Payment] Fetch Payment By Id'
);
export const fetchCurrentPaymentByIdSuccess = createAction(
  '[Payment] Fetch Payment By Id Success',
  props<{ payment: Payment }>()
);
export const fetchCurrentPaymentByIdFailed = createAction(
  '[Payment] Fetch Payment By Id Failed',
  props<{ error: Error }>()
);

// fetch transaction by id
export const fetchCurrentTransactionById = createAction(
  '[Payment] Fetch Transaction By Id'
);
export const fetchCurrentTransactionByIdSuccess = createAction(
  '[Payment] Fetch Transaction By Id Success',
  props<{ transaction: Transaction }>()
);
export const fetchCurrentTransactionByIdFailed = createAction(
  '[Payment] Fetch Transaction By Id Failed',
  props<{ error: Error }>()
);
